export default __webpack_public_path__ + "static/media/onlyRobots.918ca162.svg";